import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_my-6" }
const _hoisted_2 = { class: "gfu-bt gfu-bt--b1" }
const _hoisted_3 = { class: "gfu-bt gfu-bt--b1" }
const _hoisted_4 = { class: "gfu-box gfu-box--flat gfu-box--huge _my-6 gfu-bt gfu-bt--b1" }
const _hoisted_5 = { class: "_flexwrap _mb-6" }
const _hoisted_6 = { class: "gfu-1of1 gfu-1of2--m" }
const _hoisted_7 = { class: "gfu-1of1 gfu-1of2--m _px-3 _tac" }
const _hoisted_8 = { class: "_tac" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "gfu-bt gfu-bt--b1" }
const _hoisted_11 = { class: "gfu-box gfu-box--flat gfu-box--huge _my-6 gfu-bt gfu-bt--b1" }
const _hoisted_12 = { class: "gfu-media _mb-6" }
const _hoisted_13 = { class: "gfu-media _mb-6" }
const _hoisted_14 = { class: "gfu-media _mb-6" }
const _hoisted_15 = { class: "gfu-media _mb-6" }
const _hoisted_16 = { class: "gfu-media _mb-6" }
const _hoisted_17 = { class: "_tac" }
const _hoisted_18 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_platform_feature_comparison = _resolveComponent("platform-feature-comparison")
  const _component_themed_image = _resolveComponent("themed-image")
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "gfu-hd gfu-hd--h2" }, "Feature comparison", -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, "Features that set " + _toDisplayString($options.platformName) + " apart from the competition.", 1 /* TEXT */),
    _createVNode(_component_platform_feature_comparison, { class: "_my-6" }),
    _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "gfu-hd gfu-hd--h2" }, "End-to-end marketing support", -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_3, "Combine " + _toDisplayString($options.platformName) + " audiences with the experienced performance marketing team to maximize your success.", 1 /* TEXT */),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "gfu-hd gfu-hd--h2 _mb-3 gfu-heading--top-divider _mb-3" }, "Take advantage of our know-how", -1 /* CACHED */)),
          _createTextVNode(" Our in-house team turns data into results. We create high-impact visuals, manage your performance campaigns, and share transparent updates every step of the way. Partner with us for your paid promotional strategy, and you’ll also gain priority access to free placements across " + _toDisplayString($options.platformName) + "’s owned marketing channels. ", 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_themed_image, {
            src: "/content/images/static/become-a-creator/arrow.svg",
            alt: "Take advantage of our know-how"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "_mb-1" }, "Sounds interesting?", -1 /* CACHED */)),
        _createElementVNode("a", {
          href: $options.marketingServicesUrl,
          class: "gfu-btn gfu-btn--primary gfu-btn--soft gfu-btn--wide"
        }, "Learn more", 8 /* PROPS */, _hoisted_9)
      ])
    ]),
    _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "gfu-hd gfu-hd--h2" }, "Get started with crowdfunding in just 5 steps", -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_10, "Making campaigns on " + _toDisplayString($options.platformName) + " is an easy and straightforward process.", 1 /* TEXT */),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_base_icon, {
          name: "user",
          class: "gfu-icon--big _mr-3 _tc--accent"
        }),
        _cache[2] || (_cache[2] = _createElementVNode("div", null, [
          _createElementVNode("h4", { class: "gfu-hd gfu-hd--h3 _mb-1 gfu-icon--hd" }, "Become a creator"),
          _createTextVNode(" Create a free account. It's easy, just a few clicks. ")
        ], -1 /* CACHED */))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_base_icon, {
          name: "file-check",
          class: "gfu-icon--big _mr-3 _tc--accent"
        }),
        _cache[3] || (_cache[3] = _createElementVNode("div", null, [
          _createElementVNode("h4", { class: "gfu-hd gfu-hd--h3 _mb-1 gfu-icon--hd" }, "Submit data"),
          _createTextVNode(" Share with us some information about yourself. Make sure your project is compliant with our terms of service. ")
        ], -1 /* CACHED */))
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_base_icon, {
          name: "pen-ruler",
          class: "gfu-icon--big _mr-3 _tc--accent"
        }),
        _cache[4] || (_cache[4] = _createElementVNode("div", null, [
          _createElementVNode("h4", { class: "gfu-hd gfu-hd--h3 _mb-1 gfu-icon--hd" }, "Publish a preview page"),
          _createTextVNode(" Present your project, show its best features and gather followers. Let backers know what it is about. ")
        ], -1 /* CACHED */))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_base_icon, {
          name: "rocket",
          class: "gfu-icon--big _mr-3 _tc--accent"
        }),
        _cache[5] || (_cache[5] = _createElementVNode("div", null, [
          _createElementVNode("h4", { class: "gfu-hd gfu-hd--h3 _mb-1 gfu-icon--hd" }, "Launch!"),
          _createTextVNode(" Once you're ready, set the timer to start the campaign. We'll review it and give you some hints if anything needs improving. Then, everything is in your and backers' hands! ")
        ], -1 /* CACHED */))
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_base_icon, {
          name: "truck-fast",
          class: "gfu-icon--big _mr-3 _tc--accent"
        }),
        _cache[6] || (_cache[6] = _createElementVNode("div", null, [
          _createElementVNode("h4", { class: "gfu-hd gfu-hd--h3 _mb-1 gfu-icon--hd" }, "Finalize the campaign"),
          _createTextVNode(" After successful funding and when your project is almost ready, you can set up a pledge manager to handle pledges and prepare delivery to the backers. ")
        ], -1 /* CACHED */))
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("a", {
          href: $options.becomeCreatorUrl,
          class: "gfu-btn gfu-btn--primary gfu-btn--soft gfu-btn--wide"
        }, "Launch your project", 8 /* PROPS */, _hoisted_18)
      ])
    ])
  ]))
}